import { useEffect, useState } from 'react';
import { useCalibration } from '../../../context/calibrationContext';
import { useReceiveMessage } from '../../../context/messageContext';
import { cardDimensionCalculations, rulerDimensionCalculations } from '../../../helpers/calibration-calculations';
import { ResponsiveScreenCalibrationReadout, ResponsiveScreenCalibrationSelection } from '..';
import { useAppointment } from '../../../context/appointmentContext';

const ResponsiveScreenCalibrationContainer = ({ calibrationStep, setCalibrationStep, setActiveTab }) => {
  const [patientValuesReceived, setPatientValuesReceived] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [calibrationMethod, setCalibrationMethod] = useState(null);
  const { updateCalibrationData } = useCalibration();
  const { appointment } = useAppointment();
  const receivedMessage = useReceiveMessage();

  useEffect(() => {
    if (appointment?.currentUser?.role === 'patient') {
      setUserRole('patient');
    } else setUserRole('optician');
  }, [appointment]);

  useEffect(() => {
    if (receivedMessage?.type === 'rulerDimensions') {
      setCalibrationMethod('ruler');
      const { rulerWidth, rulerHeight, screenWidthPx, screenHeightPx } = receivedMessage?.content;
      updateCalibrationData(rulerDimensionCalculations(rulerWidth, rulerHeight, screenWidthPx, screenHeightPx));
      setPatientValuesReceived(true);
      if (userRole !== 'patient') {
        return setCalibrationStep('ruler');
      }
    }

    if (receivedMessage?.type === 'cardDimensions') {
      setCalibrationMethod('card');
      const { cardWidthPx, cardHeightPx, screenWidthPx, screenHeightPx } = receivedMessage?.content;
      updateCalibrationData(cardDimensionCalculations(cardWidthPx, cardHeightPx, screenWidthPx, screenHeightPx));
      setPatientValuesReceived(true);
    }
  }, [receivedMessage, updateCalibrationData]);

  return (
    <>
      {calibrationStep === 'screen-calibration' || calibrationStep === 'screen-calibration-selection' ? (
        <ResponsiveScreenCalibrationSelection setStep={(step) => setCalibrationStep(step)} setCalibrationStep={setCalibrationStep} />
      ) : (
        <ResponsiveScreenCalibrationReadout
          patientValuesReceived={patientValuesReceived}
          calibrationMethod={calibrationMethod}
          setActiveTab={setActiveTab}
        />
      )}
    </>
  );
};

export default ResponsiveScreenCalibrationContainer;
